import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function About() {
  return <section className="py-20 px-4 bg-dark-card/50 border-y border-dark-border" data-id="element-17">
      <div className="max-w-4xl mx-auto text-center" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-19">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-20">
            <BookOpen className="w-8 h-8 text-gold" data-id="element-21" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-8" data-id="element-22">
            Sobre Vikingos Legendarios
          </h2>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-23">
            Vikingos Legendarios nace con un objetivo claro: acercar la historia
            de los pueblos nórdicos de una forma apasionante, rigurosa y fácil
            de comprender. Cada tomo combina investigación histórica,
            arqueología y narrativa para que descubras cómo surgió, evolucionó y
            dejó su huella una de las culturas más extraordinarias de todos los
            tiempos.
          </p>
        </motion.div>
      </div>
    </section>;
}